/** @format */

import { type RouteRecordRaw } from 'vue-router';
import { LOGIN_NAME, DEMO_ERROR_404_ROUTE_NAME } from '@/router/constant';

// error 404 示例
export const DemoError404Route: RouteRecordRaw = {
	path: '/demo-error-404',
	name: DEMO_ERROR_404_ROUTE_NAME,
	component: () => import(/* webpackChunkName: "DEMO_PINIA_ROUTE_NAME" */ '@/views/error/404.vue'),
	meta: {
		title: DEMO_ERROR_404_ROUTE_NAME,
	},
};

export const LoginRoute: RouteRecordRaw = {
	path: '/login',
	name: LOGIN_NAME,
	component: () => import(/* webpackChunkName: "login" */ '@/views/login/index.vue'),
	meta: {
		title: '登录',
	},
};

const routes: Array<RouteRecordRaw> = [LoginRoute, DemoError404Route];
export default routes;
